import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './holiday.css';
import { formatedDate } from "../../../util/date";
import { Button, Table } from "reactstrap";
import TollTipChildren from "../../../components/tolltip-children/TollTipChildren";
import JourneyEditHoliday from "../../../components/journey-edit-holiday/JourneyEditHoliday";



class Holiday extends React.Component {
    holidayTypes = [
        { label: 'Feriado Nacional', value: 'NATIONAL' },
        { label: 'Feriado Estadual', value: 'STATE' },
        { label: 'Feriado Municipal', value: 'COUNTY' },
        { label: 'Ponto Facultativo', value: 'OPTIONAL' },
    ]
    columns = ['Data', 'Descrição', 'Tipo', '']

    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            alert: { msg: '', type: '' },
            loading: false,
            holidayName: '',
            showNewHoliday: false,
            table: [],
            editHoliday: false,
            filter: {
                startDate: "",
                endDate: "",
                // startDate: "2022-05-01",
                // endDate: "2022-06-30",
                holidayTypes: []
            },
            dataHoliday: {
                date: '',
                description: '',
                scope: ''
            }
        }
    }




    componentDidMount() {
        // this.getHolidays()
    }

    delete = condtion => {
        if (condtion) {
            const data = this.state.table[0]
            this.setState({ loading: true })
            axios.delete(`${url}/v1/telemetria/registrable/HolidayCrudService/${data._id}/${this.props.token}`)
                .then(d => {
                    console.log(d)
                    store.addNotification({ ...this.props.bodyNotify, title: `${data.scopeStr} foi apagado!`, type: 'warning', message: `${data.description} - ${data.date}` });
                    this.setState({ loading: false, deleteHoliday: false })
                    this.getHolidays()
                })
                .catch(e => {
                    var errorMsg = e.response.data.errorMessage
                    this.setState({ loading: false, deleteHoliday: false })
                    errorMsg.forEach(d => {
                        if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                        else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                    })
                    this.getHolidays()
                })
        } else {
            this.setState({ deleteHoliday: false })
            this.getHolidays()
        }
    }

    getHolidays = () => {
        if (!this.state.filter.startDate || !this.state.filter.endDate) return
        this.setState({ loading: true, table: [], alert: { msg: '', type: '' } });
        // console.log(data)
        const filter = {
            period: {
                startDate: this.state.filter.startDate,
                endDate: this.state.filter.endDate
            },
            type: this.state.filter.holidayTypes
        }
        axios.post(`${url}/v1/telemetria/registrable/find/HolidayCrudService/${this.props.token}`, filter)
            .then(d => {
                const alert = { msg: !d.data.length ? 'Não foi possivel localizar resultados para o período selecionado.' : '', type: '' }
                this.setState({ table: d.data, alert, loading: false })
            }).catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    editHoliday = (dataHolidayEdit, condition) => {
        if (condition) {
            this.setState({ editHoliday: true, dataHolidayEdit })
        } else {
            this.setState({ editHoliday: false, dataHolidayEdit })

        }
    }

    addHoliday = () => {
        this.setState({ loading: true, alert: {msg: '', type: ''} })
        const body = this.state.dataHoliday
        console.log(body)
        axios.put(`${url}/v1/telemetria/registrable/HolidayCrudService/${this.props.token}`, body)
            .then(d => {
                console.log(d)
                this.getHolidays()
                store.addNotification({ ...this.props.bodyNotify, title: `${this.state.holidayName} foi adicionado!`, type: 'success', message: `${body.description} - ${formatedDate(body.date)}` });
                this.clearDataHoliday()
            }).catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    
    }

    preDelete = data => {
        console.log(data)
        this.setState({ loading: true, deleteHoliday: true })
        setTimeout(() => {
            this.setState({ loading: false, table: [data] })
        }, 200);
    }

    clearDataHoliday = () => this.setState({ loading: false, showNewHoliday: false, dataHoliday: { date: '', description: '', scope: '' }, holidayName: '', alert: {msg: '', type: ''} });


    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startDate: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        // max={getFDate()}
                        value={this.state.filter.startDate} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endDate: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startDate}
                        min={this.state.filter.startDate}
                        // max={getFDate()}
                        value={this.state.filter.endDate}
                    />
                </div>
                <div>
                    <label htmlFor="tipo" className='toolbar-label'>Tipo</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='tipo'
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Tipo"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        closeMenuOnSelect={false}
                        isDisabled={this.state.loading}
                        isClearable
                        isMulti
                        options={this.holidayTypes}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, holidayTypes: [] } })
                            }
                            else {
                                let holidayTypes = []
                                i.forEach(d => holidayTypes.push(d.value))
                                this.setState({ filter: { ...this.state.filter, holidayTypes } })
                            }
                        }}
                        defaultInputValue={this.state.filter.eventType || ''}
                    />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getHolidays()}
                    disabled={this.state.loading || !this.state.filter.startDate || !this.state.filter.endDate}
                />


            </ToolBar>
        )
    }

    renderNewHoliday = () => {
        return (
            this.state.showNewHoliday ? (
                <div className="container-new-holiday">
                    <div style={{ width: '220px', marginTop: '10px', marginRight: '10px' }}>
                        <label htmlFor="holiday-date">Data</label>
                        <input
                            id='holiday-date'
                            type="date"
                            className='form-control toolbar-date input-change-color'
                            onChange={(i) => this.setState({ dataHoliday: { ...this.state.dataHoliday, date: i.target.value } })}
                            disabled={this.state.loading}
                            placeholder='Data'
                            value={this.state.dataHoliday.date} />
                    </div>

                    <div style={{ width: '220px', marginTop: '10px', marginRight: '10px' }}>
                        <label htmlFor="description">Descrição</label>
                        <input
                            id='description'
                            type="text"
                            className='form-control toolbar-date input-change-color'
                            onChange={(i) => this.setState({ dataHoliday: { ...this.state.dataHoliday, description: i.target.value } })}
                            disabled={this.state.loading}
                            placeholder='Descrição'
                            value={this.state.dataHoliday.description} />
                    </div>

                    <div style={{ width: '220px', marginTop: '10px', marginRight: '10px' }}>
                        <label htmlFor="drivers">Tipo</label>
                        {/* Select Motoristas */}
                        <Select
                            inputId='drivers'
                            className='toolbar-select select-change-color'
                            placeholder="Tipo"
                            noOptionsMessage={e => { return !e.inputValue ? 'Pesquise o tipo de feriado!' : `"${e.inputValue}" não foi encontrado!` }}
                            options={this.holidayTypes}
                            // isMulti
                            isClearable
                            defaultInputValue={this.state.holidayName}
                            closeMenuOnSelect={true}
                            onChange={(i) => {
                                if (!i) {
                                    this.setState({ dataHoliday: { ...this.state.dataHoliday, scope: '' }, holidayName: '' })
                                }
                                else {
                                    this.setState({ dataHoliday: { ...this.state.dataHoliday, scope: i.value }, holidayName: i.label })
                                }
                            }}

                            isDisabled={this.state.loading}
                        />
                    </div>
                    <div>
                        <input
                            type="button"
                            value='Cancelar'
                            className='telemetry-button btn-new-holiday btn-new-holiday-cancel'
                            onClick={() => this.clearDataHoliday()}
                            // style={{ marginBottom: '20px' }}
                            disabled={this.state.loading}
                        />
                        <input
                            type="button"
                            value='Adicionar'
                            className='telemetry-button btn-new-holiday'
                            onClick={() => this.addHoliday()}
                            // style={{ marginBottom: '20px' }}
                            disabled={
                                !this.state.dataHoliday.date ||
                                !this.state.dataHoliday.description ||
                                !this.state.dataHoliday.scope ||
                                this.state.loading}
                        />
                    </div>

                </div>
            ) : (
                <div style={{ marginLeft: '-7px' }}>
                    <input
                        type="button"
                        value='Novo Feriado'
                        className='telemetry-button btn-new-holiday'
                        onClick={() => this.setState({ showNewHoliday: true, alert: {msg: '', type: ''} })}
                        // style={{ marginBottom: '20px' }}
                        disabled={this.state.loading}
                    />
                </div>
            )
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.editHoliday ? (
                    <JourneyEditHoliday visible={this.state.editHoliday} 
                        _close={() => this.editHoliday({}, false)} 
                        data={this.state.dataHolidayEdit} holidayTypes={this.holidayTypes} 
                        token={this.props.token}
                        bodyNotify={this.props.bodyNotify}
                        _callBack={() => this.getHolidays()}/>
                ) : null}
                {!this.state.loading ? (
                    this.renderNewHoliday()
                ) : null}
                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div>
                        <div>
                            {this.state.deleteHoliday ? (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
                                    <p>Deseja Excluir o Feriado?</p>
                                    <div>
                                        <Button type="button" size="sm" color="secondary" style={{ marginRight: '10px' }} onClick={() => this.delete(true)}>SIM</Button>
                                        <Button type="button" size="sm" color="secondary" onClick={() => this.delete(false)}>NÃO</Button>
                                    </div>
                                </div>
                            ) : null}
                            <Table responsive className="table-change-color">
                                <thead>
                                    <tr>
                                        {this.columns.map((d, i) => {
                                            return (
                                                <th key={i}>{d}</th>
                                            )
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.table.map((d, i) => {
                                        return (
                                            <tr key={i} className='tr-table-pendencie tr-table-change-color'>
                                                <td className='td-table-journey-control'>{d.date}</td>
                                                <td className='td-table-journey-control'>{d.description}</td>
                                                <td className='td-table-journey-control'>{d.scopeStr}</td>
                                                <td className='td-table-journey-control'>
                                                    {!this.state.deleteHoliday ? (
                                                        <div style={{ display: 'flex' }}>
                                                            <TollTipChildren text='Editar Feriado' id={`edit-justify-${i}`}>
                                                                <Button type="button" id={`edit-justify-${i}`} outline color="warning" onClick={() => this.editHoliday(d, true)}><i className="fas fa-edit" style={{ fontSize: '18px', marginTop: '2px' }}></i></Button>
                                                            </TollTipChildren>

                                                            <div style={{ width: '20px' }}></div>
                                                            <TollTipChildren text='Apagar Feriado' id={`delete-holiday-${i}`}>
                                                                <Button type="button" id={`delete-holiday-${i}`} outline color="danger" onClick={() => this.preDelete(d)}><i className="fas fa-trash-alt" style={{ fontSize: '18px', marginTop: '2px' }}></i></Button>
                                                            </TollTipChildren>
                                                        </div>

                                                    ) : null}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>

                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default Holiday